import { signal } from '@preact/signals';
import type { ActionItem, ExecutiveSummary, ProjectTopic, AiChatMessage, SmartReplyOption } from '../types/ai';

export const actionsSignal = signal<ActionItem[]>([]);
export const summariesSignal = signal<ExecutiveSummary[]>([]);
export const projectsSignal = signal<ProjectTopic[]>([]);
export const aiChatHistorySignal = signal<AiChatMessage[]>([]);
export const isAiTypingSignal = signal<boolean>(false);

export const activeSummaryTabIndexSignal = signal<number>(0);
export const smartRepliesSignal = signal<SmartReplyOption[]>([]);
export const isGeneratingSmartRepliesSignal = signal<boolean>(false);

export const pendingNewMessagesCountSignal = signal<number>(0);
export const daysSinceLastSummarySignal = signal<number>(0);
export const isStaleSummarySignal = signal<boolean>(false);
